export default __webpack_public_path__ + "static/media/ribbon2.73745b8f.svg";